import React from "react";
import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import { useDrawer } from "./DrawerContext";

const GlobalDrawer: React.FC = () => {
  const { drawerState, closeDrawer } = useDrawer();

  return (
    <Drawer
      anchor={drawerState.anchor ?? "left"}
      open={drawerState.open}
      onClose={closeDrawer}
    >
      <Box
        sx={{
          width:
            drawerState.anchor === "top" || drawerState.anchor === "bottom"
              ? "auto"
              : 250,
        }}
        role="presentation"
        onClick={closeDrawer}
        onKeyDown={closeDrawer}
      >
        {drawerState.content}
      </Box>
    </Drawer>
  );
};

export default GlobalDrawer;
